import * as Yup from "yup";
import checkout from "./form8";

const {
  formField8: {
    endow,
    departmentLevel,
    subordinateToTheDepartment,
    city,
    district,
    commune,
    isFemale,
    sumFemale,
    confirmFemale,
    dateConfirmFemale,
    isMinority,
    sumMinority,
    confirmMinority,
    dateConfirmMinority,
    taxReductionFemale,
    taxReductionMinority
  },
} = checkout;

const validation8 = Yup.object().shape({
  [endow.name]: Yup.string().required(endow.errorMsg),
  [departmentLevel.name]: Yup.string().required(departmentLevel.errorMsg),
  [subordinateToTheDepartment.name]: Yup.string().required(subordinateToTheDepartment.errorMsg),
  [city.name]: Yup.string().required(city.errorMsg),
  [district.name]: Yup.string().required(district.errorMsg),
  [commune.name]: Yup.string().required(commune.errorMsg),
  [isFemale.name]: Yup.string().required(isFemale.errorMsg),
  [sumFemale.name]: Yup.number().when([isFemale.name], (isFemaleValue, schema) => {
    return isFemaleValue === 'true' ? schema.required(sumFemale.errorMsg) : schema;
  }),
  [confirmFemale.name]: Yup.string().notRequired(confirmFemale.errorMsg),
  [dateConfirmFemale.name]: Yup.number().notRequired(dateConfirmFemale.errorMsg),
  [isMinority.name]: Yup.string().required(isMinority.errorMsg),
  [sumMinority.name]: Yup.number().when([isMinority.name], (isMinorityValue, schema) => {
    return isMinorityValue === 'true' ? schema.required(sumMinority.errorMsg) : schema;
  }),
  [confirmMinority.name]: Yup.string().notRequired(confirmMinority.errorMsg),
  [dateConfirmMinority.name]: Yup.number().notRequired(dateConfirmMinority.errorMsg),
  [taxReductionFemale.name]: Yup.string().required(taxReductionFemale.errorMsg),
  [taxReductionMinority.name]: Yup.string().required(taxReductionMinority.errorMsg),

});

export default validation8;
